<template>
  <div class="container-custom" v-if="category !== null">
    <v-form ref="form" @submit.prevent="saveHandler">
      <!-- breadcrumbs -->
      <Breadscrumbs
        :links="[
          {
            name: 'Category',
            to: {
              name: 'Category'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'CategoryCreate'
            }
          },
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
            <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- block -->
    <div class="block">
      <!-- Category Name -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Category Name <span class="text-danger">*</span></h4>
        <div class="form-input-group w-248px my-n2">
          <input type="text" placeholder="請輸入分類名稱" v-model="category.name" required/>
        </div>
      </label>
      <!-- BU -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">BU <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2 category-autocomplete">
          <v-autocomplete
            v-model="category.bu_id"
            :items="buTabs"
            placeholder="請選擇所屬BU"
            item-text="name"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- Category Type -->
      <div class="form-item py-5 d-flex" v-if="category.bu_id == 1" >
        <h4 class="w-240px mr-10">Category Type <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2 category-autocomplete">
          <v-radio-group v-model="category.category_type" row>
            <div
              v-for="item in [
                { label: '預設', value: 'category' },
                { label: '整機', value: 'assembly' },
              ]"
              :key="item.value"
              class="w-33"
            >
              <v-radio class="mr-01" :value="item.value">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text w-202px">
                    {{ item.label }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- ID -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">ID</h4>
        <div class="d-flex">
          <div class="form-input-group w-248px my-n2">
            <input type="text" value="" disabled />
          </div>
          <div class="h5 ink-02-medium--text ml-10px">(自動生成)</div>
        </div>
      </label>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="form-input-group w-248px my-n2">
          <input type="text" placeholder="請輸入序號" v-model="category.order"/>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div>
          <FormSwitch v-model="category.status"></FormSwitch>
        </div>
      </label>
      <!-- Slug -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>Slug</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.slug"
            placeholder="可讀性URL"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SEO TITLE -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.seo_title"
            placeholder="SEO Title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SEO Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="category.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- 圖片 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於官網BU Page <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="category.image"
            dir="category"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    Breadscrumbs,
  },
  computed: {
    ...mapState(['buTabs']),
    ...mapState('category', ['category']),
  },
  async created() {
    this.setCategory({});
  },
  methods: {
    ...mapActions('category', {
      setCategory: 'setCategory',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.$router.push({ name: 'Category' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.category.name) {
          this.errors.push('Category Name required.');
        }
        if (!this.category.bu_id) {
          this.errors.push('BU required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.category).then(() => {
          this.$router.push({ name: 'Category' });
          this.clear();
        });
      }
    },
  },
};
</script>

<style lang="scss">
.category-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
